import { Segmented } from "antd";
import React, { useState } from "react";
import Copyright from "./Copyright";
import EmailTemplate from "./EmailTemplate";
import LandingPage from "./LandingPage";
import OtherLegal from "./OtherLegal";
import Privacy from "./Privacy";
import Terms from "./Terms";

const ContentManagement = () => {
  const [tab, setTab] = useState("Privacy");
  const Tabs = [
    { key: "Privacy", element: <Privacy /> },
    { key: "Terms", element: <Terms /> },
    { key: "Copyright", element: <Copyright /> },
    { key: "Other Legal Information", element: <OtherLegal /> },

    { key: "Landing Page", element: <LandingPage /> },

    { key: "Email Template", element: <EmailTemplate /> },
  ];
  return (
    <div>
      <h3 className="my-10">Content Management</h3>
      <Segmented
        className="my-5"
        options={[
          "Privacy",
          "Terms",
          "Copyright",
          "Other Legal Information",
          "Landing Page",
          "Email Template",
        ]}
        value={tab}
        onChange={(e) => setTab(e)}
      />
      {Tabs.find((e) => e.key === tab).element}
    </div>
  );
};

export default ContentManagement;
